import { gql } from "@apollo/client";

export const GetItmsChallans = gql`
  query GetItmsChallans(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $startDate: Time
    $endDate: Time
    $orderBy: ItmsChallansOrder
    $challanTypeIn: [ItmsChallanType!]
  ) {
    GetItmsChallans(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      startDate: $startDate
      endDate: $endDate
      orderBy: $orderBy
      where: { or: [{ challanTypeIn: $challanTypeIn }] }
    ) {
      edges {
        node {
          id
          date
          stopLine
          seatBelt
          jumpingSignal
          tripleRide
          noHelmet
          overSpeed
          driverOnCall
          total
          customerID
          challanType
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetItmsChallansNode = gql`
  query GetItmsChallansNode($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      ... on ItmsChallans {
        id
        date
        stopLine
        seatBelt
        jumpingSignal
        tripleRide
        noHelmet
        overSpeed
        driverOnCall
        total
        customerID
        challanType
      }
    }
  }
`;

export const GetItmsChallansTotalCount = gql`
  query GetItmsChallansTotalCount(
    $token: String!
    $customer_id: ID!
    $startDate: Time
    $endDate: Time
  ) {
    GetItmsChallansTotalCount(
      token: $token
      customer_id: $customer_id
      startDate: $startDate
      endDate: $endDate
    ) {
      stopLine
      seatBelt
      jumpingSignal
      tripleRide
      noHelmet
      overSpeed
      driverOnCall
      total
    }
  }
`;

export const ExportItmsChallans = gql`
  query ExportItmsChallans(
    $token: String!
    $customer_id: ID!
    $startDate: Time
    $endDate: Time
    $challanType: ItmsChallanType
  ) {
    ExportItmsChallans(
      token: $token
      customer_id: $customer_id
      startDate: $startDate
      endDate: $endDate
      challanType: $challanType
    )
  }
`;

export const ExportItmsChallansTemplate = gql`
  query ExportItmsChallansTemplate($token: String!, $customerID: ID!) {
    ExportItmsChallansTemplate(token: $token, customerID: $customerID)
  }
`;

export const ValidateItmsChallansForImport = gql`
  query ValidateItmsChallansForImport(
    $token: String!
    $customerID: ID!
    $input: ImportItmsChallansData!
  ) {
    ValidateItmsChallansForImport(
      token: $token
      customerID: $customerID
      input: $input
    )
  }
`;
